import frame13627897852Png from '@listening/assets/astro/images/Frame-1362789785-2.png';
import frame13627897853Png from '@listening/assets/astro/images/Frame-1362789785-3.png';
import starSvg from '@listening/assets/astro/images/star.svg';

import { CtaButton } from '@/components/astro/cta-button/cta-button';

export function CustomerTestimonialsShortSection() {
  return (
    <section className='flex flex-col items-center justify-center gap-8 overflow-visible px-[20px] py-8 sm:gap-14 sm:p-14 lg:gap-18 lg:p-18'>
      <div className='flex max-w-[1296px] flex-col gap-[24px]'>
        <div className='flex flex-col gap-8 md:flex-row'>
          <div className='flex flex-1 items-stretch gap-4 rounded-2xl border border-solid border-neutral-210 p-4 sm:gap-8 sm:p-8'>
            <img
              alt='Jayati S. avatar'
              className='w-[48px] self-start sm:w-auto sm:self-center'
              loading='lazy'
              src={frame13627897852Png}
            />
            <div className='flex flex-1 flex-col gap-4'>
              <div className='text-[16px] leading-[24px] text-neutral-700 sm:text-[18px] sm:leading-[27px]'>
                Having an app that converts all my reading into voice is just so
                convenient and amazing
              </div>
              <div className='mt-auto flex justify-between'>
                <div className='leading-[21px] font-[500] text-neutral-945 sm:leading-normal'>
                  Jayati S.
                </div>
                <div className='flex'>
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                </div>
              </div>
            </div>
          </div>
          <div className='flex flex-1 items-stretch gap-4 rounded-2xl border border-solid border-neutral-210 p-4 sm:gap-8'>
            <img
              alt='Anna V. avatar'
              className='w-[48px] self-start sm:w-auto sm:self-center'
              loading='eager'
              src={frame13627897853Png}
            />
            <div className='flex flex-1 flex-col gap-4'>
              <div className='text-[16px] leading-[24px] text-neutral-700 sm:text-[18px] sm:leading-[27px]'>
                I’m really picky about AI voices, but this one was amazing! Even
                at 1.5x speed, it was engaging to listen to. It’s a game changer
                to be able to listen while walking!
              </div>
              <div className='mt-auto flex justify-between'>
                <div className='leading-[21px] font-[500] text-neutral-945 sm:leading-normal'>
                  Anna V.
                </div>
                <div className='flex'>
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CtaButton className='inline-block h-auto cursor-pointer rounded-full border-0 bg-azure-455 p-4 text-center text-[18px] leading-[24px] font-[500] text-neutral-50 no-underline sm:px-6 sm:text-[28px] sm:leading-[37px] lg:px-16 lg:py-5' />
    </section>
  );
}
